import React from "react";
import { Chip, Tooltip, IconButton } from "@mui/material";
import {
  CheckCircle as ResolveIcon,
  Undo as RevertIcon,
} from "@mui/icons-material";
import type { ShipmentFeedError } from "@services/shipments/types";

interface ShipmentErrorChipProps {
  error: ShipmentFeedError;
  count?: number;
  onResolve: (errorId: string, revert?: boolean) => void;
}

export function ShipmentErrorChip({
  error,
  count = 1,
  onResolve,
}: ShipmentErrorChipProps) {
  const errorLabel =
    count > 1
      ? `${error.type}: (${count}) ${error.message}`
      : `${error.type}: ${error.message}`;
  const fullErrorTooltip =
    count > 1
      ? `Type: ${error.type}\nMessage: ${error.message}\nCount: ${count} errors`
      : `Type: ${error.type}\nMessage: ${error.message}`;

  return (
    <Tooltip title={fullErrorTooltip} placement="top">
      <Chip
        label={errorLabel}
        size="small"
        color={error.resolved ? "default" : "error"}
        sx={{
          maxWidth: 200,
          "& .MuiChip-label": {
            paddingLeft: error.resolved ? undefined : "4px",
          },
        }}
        icon={
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onResolve(error.id!, error.resolved);
            }}
            sx={{
              padding: 0,
              width: 16,
              height: 16,
              marginLeft: "4px",
              "& .MuiSvgIcon-root": {
                fontSize: 14,
              },
            }}
          >
            {error.resolved ? <RevertIcon /> : <ResolveIcon />}
          </IconButton>
        }
      />
    </Tooltip>
  );
}
